import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import * as _ from "lodash";
import * as fromRootStore from "../../../../reducers";
import { CommonService } from "../../../../services/common.service";
import { Combo2Service, ComboService, ExcelService, PurchaseReportService,SalesOrderService } from "../../../../services/index";
declare var google;

@Component({
  selector: "plainSoReport",
  templateUrl: "./plainSoReport.html"
})
export class plainSoReport implements OnInit {
  @Input("tabTitle") title: string;
  @Input("tabID") tabID: string;
  @Input("params") params: any;
  @Input() active = false;
  @Input() dataContext;
  @Output() tabUpdateEvent = new EventEmitter();

  seasonList = [];
  styleList = [];
  gridOptions: any;
  dataList = [];
  qualityList: any;
  typeList = [
    {
      type: "DESIGN WISE",
    },
    {
      type: "SHADE WISE",
    },
  ];
  StyletypeList = [
    {
      type: "FORMAL PLAIN",
    },
    {
      type: "FORMAL CLUB",
    },
    {
      type: "FORMAL SV",
    },
    {
      type: "FORMAL OTHERS",
    },
  ];

  codeList: any;
  brandList: any[];
  seasonfinList = [];
  isLoadMask: Promise<any>;
  selectedDlrMapList: any[];
  loadingIndicator: boolean = true;
  reorderable: boolean = true;
  finyearList = [];
  exceldata: any;
  groupbyList = ["DESIGN NO", "WO NO"];
  filter = {
    from_date: "",
    to_date: "",
    variety: "",
    design: "",
    style: "",
    color: "",
    groupby: "stkl_style",
    from_range: '',
    to_range: '',
    ord_from:'',
    ord_to:''
  };
  page = {
    limit: 25,
    count: 0,
    offset: 0,
    orderBy: "wo_no",
    orderDir: "asc",
  };
  printConfig: any = {
    title: "WorkOrder Report",
    columns: [],
    rows: [],
  };
  
  colorList = [
    "lightcyan",
    "bisque",
    "lightblue",
    "lightgoldenrodyellow",
    "thistle",
    "floralwhite",
    "#fbd4da",
    "#f2cd75",
    "lightgrey",
     "#ccebcc"
  ];

  partyList = [];
  @ViewChild("filterPanel") filterPanel;

  finyearCtrl: FormControl = new FormControl();
  seasonCtrl: FormControl = new FormControl();
  agentCtrl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();
  parentCtrl: FormControl = new FormControl();
  columns = [];
  partycodeList = [];
  toggleCol = [];
  menu: any;
  reportTypeList = ["DESIGN NO", "PARTY", "PURCHASE"];
  reportName = "design_no";
  reportType = "Design";
  filterExpand = false;
  filterData: any;
  agentList$ = [];
  swatchList = ["YES", "NO"];
  sampList = ["YES", "NO"];
  user: any;
  agentVisible: boolean = false;
  companyInfo: any = [];
  orderList: any = [];
  constructor(
    public store: Store<fromRootStore.State>,
    private commonserv: CommonService,
    private excelService: ExcelService,
    private combo: Combo2Service,
    private purReport: SalesOrderService,
    public datePipe: DatePipe,
    public comboservice: ComboService,
  ) {
    this.filter.from_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
    this.filter.to_date = this.datePipe.transform(new Date(), "yyyy-MM-dd");
  }

  ngOnInit(): void {
    this.getColumns();
    this.finyearCombo();
    // this.getSeasonList();
    this.brandlist();
    this.toggleCol = Object.assign({}, this.columns);
  }

  hotkeys(event) {
    if (this.active) {
    }
  }

  getColumns() {
    this.columns = [
      {
        name: "SNo",
        prop: "sno",
        type: "sno",
        minWidth: 80,
        maxWidth: 80,
        width: 80,
        sortable: false,
        toggle: true,
        cellClass: "text-center",
        headerClass: "text-center",
      },
      {
        name: "WO.NO",
        prop: "wo_no",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
      },
      {
        name: "Fabric Design",
        prop: "fab_design",
        minWidth: 130,
        maxWidth: 130,
        width: 130,
        headerClass: "text-center",
      },
      {
        name: "Shirt design",
        prop: "shirtdno",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "Width",
        prop: "width",
        cellClass: "text-center",
        minWidth: 120,
        maxWidth: 120,
        width: 120,
        headerClass: "text-center",
      },
      {
        name: "Brand",
        prop: "brand",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "F/S",
        prop: "ftot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "H/S",
        prop: "htot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
      {
        name: "GR.Tot",
        prop: "gr_tot",
        cellClass: "text-right",
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        headerClass: "text-center",
      },
    ];

    this.gridOptions = {
      columns: this.columns,
      loading: true,
      data: [],
    };
    this.toggleCol = Object.assign({}, this.columns);

    this.pageCallback({ offset: 0 });
  }

  finyearCombo() {
    let that = this;
    this.combo.finyearCombo().then((res: any) => {
      that.finyearList = res.data;
      // that.filter.finyear = res.data[0].finyear;
      // that.filter.fin_id = res.data[0].fin_id;
      // that.finyearCtrl.setValue(res.data[0].fin_id);
      // that.onSelectFinyear(res.data[0].fin_id);
      // that.getSeasonList();
    });
  }
  // getSeasonList() {
  //   let params = {
  //     date: new Date().getFullYear(),
  //     page: 1,
  //     start: 0,
  //     limit: 100,
  //   };
  //   this.comboservice.getBrandNewSeason(params).then((res: any) => {
  //     this.seasonList = res;
  //     this.allseason();
  //     this.seasonCtrl.setValue(res[res["length"] - 1].season_id);
  //     this.getOrderList();
  //   });
  // }
  // allseason() {
  //   let fin_id = parseInt(this.filter.fin_id);

  //   this.seasonList.forEach(() => {
  //     let seasonAll = {
  //       season: "ALL",
  //       season_id: this.seasonList[this.seasonList["length"] - 1].season_id + 1,
  //       fin_id: fin_id,
  //     };
  //     if (fin_id > 0) {
  //       this.seasonList.push(seasonAll);
  //     }
  //     fin_id = fin_id - 1;
  //   });
  // }
  // onSelectFinyear(id) {
  //   this.filter.season_id = "";
  //   var fin_id = id;
  //   // let seasonfinList = _.filter(this.seasonList, fin_id );
  //   let seasonfinList = this.seasonList.filter((res) => res.fin_id == fin_id);
  //   this.seasonfinList = seasonfinList;
  //   this.seasonCtrl.setValue(
  //     this.seasonfinList[this.seasonfinList["length"] - 1].season_id
  //   );
  //   this.filter.season_id = this.seasonfinList[
  //     this.seasonfinList["length"] - 1
  //   ].season_id;
  //   this.filter.season = this.seasonfinList[
  //     this.seasonfinList["length"] - 1
  //   ].season;
  // }
  // displayFinyear(comboType: string, id: number) {
  //   let list: any = [];
  //   if (comboType == "Finyear") {
  //     list = this.finyearList;
  //   }
  //   if (id && list.length > 0) {
  //     let fitem = _.find(list, { fin_id: id });
  //     return fitem["finyear"];
  //   }
  //   return "";
  // }
  displayFn(comboType: string, id: number) {
    let list: any = [];
    let that = this;
    list = that.seasonList;

    if (id && list.length > 0) {
      let fitem = _.find(list, { season_id: id });
      return fitem["season"];
    }
    return "";
  }

  onOpenedFilter(): void {
    setTimeout(function () {
      $("#party_code").focus();
    }, 100);
  }
  exportToExcel($event) {
    this.excelService.exportAsExcelFile(this.exceldata, this.title);
  }

  onChangePageSize(limit) {
    this.page.limit = 10000;
    //this.getSalesinvReport();
  }

  onColumnToggle(colToShow) {
    this.columns = colToShow;
  }

  onEnterKeyPressed(nextEl: string, ind, item) {
    if ($(".swal2-container").length > 0) {
      return false;
    } else {
      let a = $(".mat-autocomplete-panel.mat-autocomplete-visible");
      a.removeClass("mat-autocomplete-visible");
      $("#" + nextEl).focus();
    }
  }

  /**
   * Called whenever the user changes page
   */
  pageCallback(pageInfo: {
    count?: number;
    pageSize?: number;
    limit?: number;
    offset?: number;
  }) {
    this.page.offset = pageInfo.offset;
    this.getOrderList();
  }

  /**
   * Called whenever the user changes the sort order
   */
  sortCallback(sortInfo: {
    sorts: { dir: string; prop: string }[];
    column: {};
    prevValue: string;
    newValue: string;
  }) {
    // there will always be one "sort" object if "sortType" is set to "single"
    this.page.orderDir = sortInfo.sorts[0].dir;
    this.page.orderBy = sortInfo.sorts[0].prop;
    // this.getSalesinvReport();
  }

  onCellClick(event) {
    let row = event.row;  if (this.filter.groupby == "stkl_style") {
      this.filter.groupby = "stkl_variety"
      this.filter.style = row.style;

    }
    else if (this.filter.groupby == "stkl_variety") {
  
      this.filter.groupby = "stkl_design"
      this.filter.variety = row.type;
    }
    else if (this.filter.groupby == "stkl_design") {
      this.filter.groupby = "stkl_color"
          this.filter.design = row.design_no;
    }
    else if (this.filter.groupby == "stkl_color") {
      this.filter.groupby = "stkl_party"
      this.filter.color = row.color
    }
    // this.filter.type = "SHADE WISE";


    this.getOrderList();
  }
  brandlist() {
    let data = this.commonserv.itemMaster();
    let brand = data.brand;
    this.brandList = brand;
    let style = data.style;
    this.styleList = style;
  }

  // onClickwidth(selected, name, status) {
  //   if (status == true) {
  //     selected.push(name);
  //     this.filter.width = selected;
  //     //this.fil['brand'] = selected;
  //   }
  //   if (status == false) {
  //     var n = selected.indexOf(name);
  //     selected = selected.splice(n, 1);
  //   }
  // }
  // onClickbrand(selected, name, status) {
  //   if (status == true) {
  //     selected.push(name);
  //     this.filter.brand = selected;
  //     //this.fil['brand'] = selected;
  //   }
  //   if (status == false) {
  //     var n = selected.indexOf(name);
  //     selected = selected.splice(n, 1);
  //   }
  // }
  onClickstyle(selected, name, status) {
    if (status == true) {
      selected.push(name);
      this.filter.style = selected;
      //this.fil['brand'] = selected;
    }
    if (status == false) {
      var n = selected.indexOf(name);
      selected = selected.splice(n, 1);
    }
  }

  applyFilter(): void {
    //this.filterExpand = false;


    this.getOrderList();
  }

  getOrderList(): void {
    this.filter.from_date = this.datePipe.transform(
      this.filter.from_date,
      "yyyy-MM-dd"
    );
    this.filter.to_date = this.datePipe.transform(
      this.filter.to_date,
      "yyyy-MM-dd"
    );
    // if (this.filter.from_date || this.filter.to_date) {
    //   this.filter.season_id = '';

    // }
    //this.filter.order_to_date = this.datePipe.transform(this.filter.order_to_date, 'yyyy-MM-dd');
    let params = {
      start: `${this.page.offset * (this.page.limit + 1)}`,
      limit: `${this.page.limit}`,
      page: "1",
      orderColumn: `${this.page.orderBy}`,
      orderDir: `${this.page.orderDir}`,
      filter: JSON.stringify(this.filter),
    };
    let that = this;
    that.gridOptions = {
      loading: true,
      columns: [],
    };
    //this.store.dispatch(new commonActions.LoadAllParty(params));
    let f_tot = 0;
    let h_tot = 0;
    let style_tot = 0;
    let var_tot = 0;
    this.isLoadMask = this.purReport
      .plainSoreport(params)
      .then(function (res: any) {
        that.loadingIndicator = false;
        that.page.count = res.totCnt;
        that.orderList = res.data;
        let temp = 0;
        res.data.forEach((el, ind) => {
          if(that.filter.groupby != 'stkl_design'){
            el.order_per = ((el.tot_pcs/ el.war_tot) * 100).toFixed(2);
            if(!el.order_per ||!el.war_tot)
            el.order_per = 0;
          }
          if (ind >= 10) {
            temp = temp + 1;
            if (temp == 10) {
              temp = 0;
            }

            el["background"] = that.colorList[temp];

          }
          else
            el["background"] = that.colorList[ind];

         el.del_per = ((el.del_total / el.tot_pcs) * 100).toFixed(2)
         el.avl_per = (((el.tex_shirts + el.wo_tot + el.war_tot)/ el.tot_pcs) * 100).toFixed(2)
         el.dif_per = (100 - (Number(el.del_per) +  Number(el.avl_per))).toFixed(2) ;
         el.dif_per =  el.dif_per > 0 ? el.dif_per : 0 ;
         el.total =  el.tex_shirts + el.wo_tot + el.war_tot
         el.fab_short = el.tot_pcs - el.total
         el.fab_short =  el.fab_short > 0 ? el.fab_short : '' ;
         if(that.filter.groupby == 'stkl_color'){
         el.canc_shirt = (el.canc_shirt / res.data.length).toFixed(2);
         el.n_rec_shirt = (el.n_rec_shirt / res.data.length).toFixed(2);

         }

        });
  
        that.gridOptions = {
          cols: res.cols,
          columns: res.columns,
          data: res.data,
          loading: false,
        };
        that.printConfig = {
          title: "Work Order Report",
          columns: res.columns,
          rows: that.orderList,
        };
        that.exceldata = that.getData(res.columns, res.data);
        // that.change.detectChanges();
      });
  }
  onbackbutton() {

    if (this.filter.groupby == "stkl_party") {
      this.filter.groupby = "stkl_color"
      this.filter.color = "";
    }
    else if (this.filter.groupby == "stkl_color") {
      this.filter.groupby = "stkl_design"
      this.filter.design = "";
    }
    else if (this.filter.groupby == "stkl_design") {
      this.filter.groupby = "stkl_variety"
      this.filter.variety = ""

    }
    else if (this.filter.groupby == "stkl_variety") {
      this.filter.groupby = "stkl_style"
      this.filter.style = ""
      this.filter.variety = ""

    }

    this.getOrderList();
  }
  getData(columns, data) {
    let cols = columns;
    let value = data;
    let rows = [],
      row,
      ind,
      type,
      val,
      rlen = data.length,
      clen = columns.length;

    for (let i = 0; i < data.length; i++) {
      let sno = i + 1;
      row = Object.assign({}, data[i]);
      let newrow = {
        Sno: sno,
      };
      for (let j = 1; j < clen; j++) {
        let type = cols[j].type,
          index = cols[j].index,
          prop = cols[j].prop,
          name = cols[j].name;

        newrow[name] = row[prop];
      }

      rows.push(newrow);
      sno++;
    }
    return rows;
  }

  getRowClass(event) {
    return event.rowtype == "summary" ? "summary-row" : "";
  }

  refreshData() {
    let columns = this.columns,
      data = this.dataList,
      row = this.getSummaryRow(data, columns);
    data.push(row);
    this.page.count = data.length;
    // this.dataList = data;
  }

  getSummaryRow(data, columns) {
    let row = {
      type: "summary",
    };
    for (let i = 0; i < columns.length; i++) {
      let col = columns[i];
      switch (col.summary) {
        case "sum":
          let total = 0;
          for (let j = 0; j < data.length; j++) {
            let dat = data[j];
            total += dat[col.prop];
          }
          row[col.prop] = Math.round(total * 100) / 100;
          break;
        default:
          row[col.prop] = "";
          break;
      }
    }
    return row;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/report/SalesOrderReports/designSoReport/plainSoReport.ts